import {
  GET_APPLICATION_STATUS_DEF,
  GET_APPLICATION_STATUS_DEF_SUCCESS,
  API_ERROR
  
  } from "./actionTypes"
  
    
  export const getApplicationStatusDef = () => ({
    type: GET_APPLICATION_STATUS_DEF,
  })
  
  export const getApplicationStatusDefSuccess = record => ({
    type: GET_APPLICATION_STATUS_DEF_SUCCESS,
    payload: record,
  })
  
  export const applicationStatusDefError = error => {
    return {
      type: API_ERROR,
      payload: error,
    }
  }
  
  